<template>
    <div :id="uniqueId" class="w-100">
        <select 
            :class="'disabled-option select2-vue-component ' + classes" 
            style="width: 50% !important;"
            :id="customId" 
            ref="select2Element"
        >
            <option value="" v-if="!noEmptyOption" selected disabled>{{ placeholder }}</option>
            <template v-if="!noLang">
                <option v-for="(value, index) in values"
                    :key="index"
                    :value="value.code ? value.code.toLowerCase() : ''"
                >{{ value[$store.state.$siteSettings['current_lang']] ? value[$store.state.$siteSettings['current_lang']] : '---' }}</option>
            </template>
            <template v-else-if="notKeyed">
                <option v-for="(value, index) in values" 
                    :key="index" 
                    :value="value.key"
                >{{ value.text }}</option>
            </template>
            <template v-else-if="packageTemplate">
                <option v-for="(value, index) in values" 
                    :key="index" 
                    :value="index"
                >{{ value.title }}</option>
            </template>
            <template v-else>
                <option v-for="(value, index) in values" 
                    :key="index" 
                    :value="useIndexes ? index.trim() : (lowerCaseIndices ? value.toLowerCase().trim() : value.trim())"
                >{{ value }}</option>
            </template>
        </select>
    </div>
</template>

<script>
import store from "../../../store";
export default {
    store,
    data: function(){
        return {
            uniqueId: undefined,
        };
    },
    props:{
        values:{
            required: true,
        },
        placeholder:{
            type: String,
            required: false,
            default: '',
        },
        classes:{
            type: String,
            required: false,
            default: '',
        },
        value: {
            type: String,
            required: false,
        },
        noLang:{
            type: Boolean,
            required: false,
            default: false,
        },
        useIndexes: {
            type: Boolean,
            required: false,
            default: false,
        },
        specialName:{
            type: String,
            required: false,
        },
        customId:{
            type: String,
            required: false,
            default: undefined,
        },
        notKeyed:{
            type: Boolean,
            required: false,
            default: false,
        },
        packageTemplate:{
            type: Boolean,
            required: false,
            default: false,
        },
        dropDownClass:{
            type: String,
            required: false,
            default: '',
        },
        noEmptyOption:{
            type: Boolean,
            required: false,
            default: false,
        },
        dropDownParent:{
            type: String,
            required: false,
            default: '',
        },
        lowerCaseIndices:{
            type: Boolean,
            required: false,
            default: true,
        },
        allowNewOptions:{
          type: Boolean,
          required: false,
          default: false,
        }
    },
    created: function(){
        let vueThis = this;
       
        vueThis.uniqueId = 'select2_' + Math.floor(Math.random() * Date.now());

        vueThis.$nextTick(function() {
            setTimeout(function() {
                let selectElement = $(`#${vueThis.uniqueId}`).find('.select2-vue-component');

                let select2Options = {
                    width: '100%',
                    dropdownCssClass: vueThis.dropDownClass,
                    language: {
                        noResults: function(){
                            return vueThis.$helper.trans('No_results_found');
                        }                    
                    },
                    tags: vueThis.allowNewOptions,
                }

                if (vueThis.dropDownParent) {                    
                    select2Options.dropdownParent = $(vueThis.dropDownParent).eq(0)
                }      
    
                selectElement.select2(select2Options);              

                if(vueThis.value){
                    selectElement.val(vueThis.value).trigger('change');
                }
                selectElement.on('change', function(){
                    vueThis.$emit('input', $(this).val());
                });

                if(vueThis.specialName === 'shipperAddressInformation'){
                    vueThis.$store.state.awaitingActions.refreshStateOrProvince.shipperAddressInformation = false
                } else if(vueThis.specialName === 'deliveryAddressInformation'){
                    vueThis.$store.state.awaitingActions.refreshStateOrProvince.deliveryAddressInformation = false
                }
            }, 250);
        });
    },
    methods: {
        updateValues(newValues) {
            let select2Element = $(this.$refs.select2Element);
            select2Element.empty();
            
            $.each(newValues, function (index, value) { 
                select2Element.append(
                    $('<option>', {
                        value: index,
                        text: value
                    })
                );
            });      
           
            select2Element.trigger('change');
        },   
    },
    watch: {
        '$store.state.commercialInvoiceModal.differentAddress.countryCode': function() {
            let country = this.$store.state.to.country;
            $(`#${this.uniqueId}`).find('.select2-vue-component').val(country).trigger('change.select2');                  
        },
        '$store.state.awaitingActions.refreshStateOrProvince.shipperAddressInformation': function(){
            let vueThis = this;
            if(vueThis.specialName !== 'shipperAddressInformation' || !vueThis.$store.state.awaitingActions.refreshStateOrProvince.shipperAddressInformation){
                return;
            }
            setTimeout(function(){
                vueThis.$store.state.awaitingActions.refreshStateOrProvince.shipperAddressInformation = false
            }, 100);

            let newValue = vueThis.$store.state.shipperAddressInformation.stateOrProvince;
            newValue = newValue ? newValue.toLowerCase() : '';
            $(`#${vueThis.uniqueId}`).find('.select2-vue-component').val(newValue).trigger('change.select2');
        },
        '$store.state.awaitingActions.refreshStateOrProvince.deliveryAddressInformation': function(){
            let vueThis = this;
            if(vueThis.specialName !== 'deliveryAddressInformation' || !vueThis.$store.state.awaitingActions.refreshStateOrProvince.deliveryAddressInformation){
                return;
            }
            setTimeout(function(){
                vueThis.$store.state.awaitingActions.refreshStateOrProvince.deliveryAddressInformation = false
            }, 100);

            let newValue = vueThis.$store.state.deliveryAddressInformation.stateOrProvince;
            newValue = newValue ? newValue.toLowerCase() : '';
            $(`#${vueThis.uniqueId}`).find('.select2-vue-component').val(newValue).trigger('change.select2');
        },
        '$store.state.carrierInfo.carrierTimeFrom': function(){
            if(this.specialName !== 'carrierPickupTimeStart'){
                return;
            }

            $(`#${this.uniqueId}`).find('.select2-vue-component').val(this.$store.state.carrierInfo.carrierTimeFrom).trigger('change.select2');
            this.$forceUpdate();
        },
        '$store.state.carrierInfo.carrierTimeTo': function(){
            if(this.specialName !== 'carrierPickupTimeEnd'){
                return;
            }

            $(`#${this.uniqueId}`).find('.select2-vue-component').val(this.$store.state.carrierInfo.carrierTimeTo).trigger('change.select2');
            this.$forceUpdate();
        },
    },
};
</script>
